import { Component, Inject } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { firstValueFrom } from "rxjs";

import { AccountService } from "@bitwarden/common/auth/abstractions/account.service";
import { getUserId } from "@bitwarden/common/auth/services/account.service";
import { withPasswordManagerSdk } from "@bitwarden/common/key-management/utils";
import { I18nService } from "@bitwarden/common/platform/abstractions/i18n.service";
import { SdkService } from "@bitwarden/common/platform/abstractions/sdk/sdk.service";
import { DIALOG_DATA, DialogRef, ToastService } from "@bitwarden/components";
// eslint-disable-next-line no-restricted-imports
import { KdfConfig, KdfType } from "@bitwarden/legacy-crypto";

// FIXME(https://bitwarden.atlassian.net/browse/CL-764): Migrate to OnPush
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: "app-change-kdf-confirmation",
  templateUrl: "change-kdf-confirmation.component.html",
  standalone: false,
})
export class ChangeKdfConfirmationComponent {
  kdfConfig: KdfConfig;

  form = new FormGroup({
    masterPassword: new FormControl<string | null>(null, Validators.required),
  });
  showPassword = false;
  loading = false;

  constructor(
    private i18nService: I18nService,
    @Inject(DIALOG_DATA) params: { kdf: KdfType; kdfConfig: KdfConfig },
    private accountService: AccountService,
    private toastService: ToastService,
    private sdkService: SdkService,
    private dialogRef: DialogRef<ChangeKdfConfirmationComponent>,
  ) {
    this.kdfConfig = params.kdfConfig;
  }

  submit = async () => {
    if (this.form.invalid) {
      return;
    }
    this.loading = true;
    await this.makeKeyAndSave();
    this.toastService.showToast({
      variant: "success",
      message: this.i18nService.t("encKeySettingsChanged"),
    });
    await this.dialogRef.close();
    this.loading = false;
  };

  private async makeKeyAndSave() {
    const activeAccountId = await firstValueFrom(getUserId(this.accountService.activeAccount$));

    const masterPassword = this.form.value.masterPassword!;

    // Ensure the KDF config is valid.
    this.kdfConfig.validateKdfConfigForSetting();

    await withPasswordManagerSdk(activeAccountId, this.sdkService, async (sdk) => {
      await sdk.user_crypto_management().change_kdf(masterPassword, this.kdfConfig.toSdkConfig());
    });
  }
}
